import { ShieldCheck, Inbox, Receipt, ShieldAlert, CheckCircle2, ChevronRight } from "lucide-react";

const TASK = {
  approvals: { icon: ShieldCheck, color: "#f59e0b" },
  inquiries: { icon: Inbox, color: "#3b82f6" },
  overdue: { icon: Receipt, color: "#f43f5e" },
  security: { icon: ShieldAlert, color: "#f43f5e" },
};

export function TaskCenter({ tasks = [], t, onGoto }) {
  const empty = tasks.length === 0;
  return (
    <div
      data-testid="control-task-center"
      className="flex h-full flex-col rounded-xl border border-zinc-800 bg-zinc-900 p-5"
    >
      <div className="mb-4 flex items-center justify-between border-b border-zinc-800/60 pb-4">
        <h3 className="flex items-center gap-2 font-heading text-base font-bold text-white">
          <span className="h-2 w-2 rounded-full" style={{ background: empty ? "#10b981" : "#f59e0b" }} />
          {t("control.today")}
        </h3>
        {!empty && (
          <span className="rounded-full bg-amber-500/10 px-2 py-0.5 text-xs font-bold text-amber-400">
            {tasks.reduce((s, x) => s + (x.count || 0), 0)}
          </span>
        )}
      </div>

      {empty ? (
        <div className="flex flex-1 flex-col items-center justify-center gap-3 py-8 text-center" data-testid="task-center-empty">
          <CheckCircle2 className="h-9 w-9 text-emerald-400" />
          <div>
            <div className="text-sm font-medium text-zinc-200">{t("task.emptyTitle")}</div>
            <div className="mt-1 text-xs text-zinc-500">{t("task.emptySub")}</div>
          </div>
        </div>
      ) : (
        <div className="flex flex-col gap-2">
          {tasks.map((task) => {
            const meta = TASK[task.key] || { icon: Inbox, color: "#a1a1aa" };
            const Icon = meta.icon;
            return (
              <button
                key={task.key}
                data-testid={`task-${task.key}`}
                onClick={() => onGoto && onGoto(task.section)}
                className="group flex items-center gap-3 rounded-lg border border-transparent p-3 text-left transition-colors hover:border-zinc-700 hover:bg-zinc-800/50"
              >
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-zinc-800" style={{ color: meta.color }}>
                  <Icon className="h-4 w-4" />
                </span>
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-medium text-zinc-100">{t(`task.${task.key}`)}</div>
                  <div className="text-xs text-zinc-500">{t("control.review")}</div>
                </div>
                <span className="font-mono text-lg font-bold" style={{ color: meta.color }}>{task.count}</span>
                <ChevronRight className="h-4 w-4 text-zinc-600 transition-transform group-hover:translate-x-0.5 group-hover:text-zinc-300" />
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
